import { RootReducerState } from '../index';

export const selectPermissions = (state: RootReducerState): string[] => state.userPermissionsReducer.permissions;
